module.exports = __webpack_public_path__ + "static/homepage-image2-a4c0cfabfd39521d4440f08698a4ac90.jpg";